import { IRequesterInfo, KeyValuePair } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { toDrillPath } from '../drilldownModel'
import { IDrillSelection, IQuestionPage } from '../models'
import { addDealerType, DealerTypeFilter } from '../../ChatbotAnalytics/analyticsQuery'

/** Detay yolundaki turların bayi sorusu ve asistan yanıtı, sayfalı (ADR-022 §2; ayrı yetki). */
export class GetChatbotManagementQuestionsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'admin/chatbot-reports/management/questions', requesterInfo })
  }

  public async getQuestions(
    fromUtc: Date,
    toUtc: Date,
    path: Pick<IDrillSelection, 'dimension' | 'key'>[],
    page: number,
    includeTestDealers = false,
    dealerType?: DealerTypeFilter
  ): Promise<IQuestionPage> {
    const query = new KeyValuePair<string>()
    query.add('fromUtc', fromUtc.toISOString())
    query.add('toUtc', toUtc.toISOString())
    query.add('path', toDrillPath(path))
    query.add('page', String(page))
    query.add('includeTestDealers', String(includeTestDealers))
    addDealerType(query, dealerType)
    this.queryParams = query
    return await this.getAsync<IQuestionPage>()
  }
}
